export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 70,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'goodsName',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    minWidth: 220,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'hxSkuNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayNo' },
  },
  {
    title: '来源单号',
    field: 'hxPreOrderNo',
    minWidth: 170,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
        min: 0,
        step: 1,
        precision: 0,
        controls: false,
      },
    },
  },
  {
    title: that.$l('table_label_purchaseQty') || '采购数量',
    field: 'purchaseQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
        min: 0,
        step: 1,
        precision: 0,
        controls: false,
      },
    },
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnQty') || '箱数',
    field: 'ctnQty',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_purchasePrice') || '采购单价',
    field: 'purchasePrice',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
        min: 0,
        step: 0.01,
        precision: 2,
        controls: false,
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subAmount') || '采购金额',
    field: 'subAmount',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_earliestDeliveryDate') || '期望最早交货日期',
    field: 'earliestDeliveryDate',
    width: 130,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_actualDeliveryDate') || '实际最早交货日期',
    field: 'actualDeliveryDate',
    width: that.disabled ? 130 : 160,
    align: 'center',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElDatePicker',
      props: {
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shippedQty') || '已出货数量',
    field: 'shippedQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_invQty') || '剩余未出数量',
    field: 'invQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_remark') || '备注',
    field: 'remark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 500,
        clearable: true,
        size: 'mini',
      },
    },
  },
]
